import OnboardingWizard from "./components/onboarding-wizard/onboarding-wizard";
import { useEffect } from "react";
import onboardingNavigationStore from "./stores/onboarding-navigation-store";
import { observer } from "mobx-react";
import { IOnboardingScreenStore } from "./stores/onboarding-data-store";
import './onboarding-page.scss';
import { PageLoader } from "../../components/page-loader/page-loader";
import dashboardSettingsStore from "../../stores/dashboard-settings-store";

export interface IStepComponent {
    store: IOnboardingScreenStore;
}


const OnboardingPage: React.FC = observer(() => {
    useEffect(() => {
        dashboardSettingsStore.isOnboardingWizardShown = true;
        onboardingNavigationStore.load();

        return () => {
            dashboardSettingsStore.isOnboardingWizardShown = false;
        }
    }, []);

    if (!onboardingNavigationStore.isLoaded) {
        return <PageLoader/>;
    }

    const currentStep = onboardingNavigationStore.getCurrentStep();
    const Component: React.FC<IStepComponent> = currentStep.component;
    const store = onboardingNavigationStore.getScreenStore(currentStep.name) as IOnboardingScreenStore;

    return (
        <div className="onboarding">
            <OnboardingWizard step={currentStep}>
                <Component store={store} />
            </OnboardingWizard>
        </div>
    );
});

export default OnboardingPage;
